import { Component, OnInit, OnDestroy } from '@angular/core';
import { EmployeeService } from '../../employee/services/employee.service';
import { LeaveService } from '../../leave/services/leave.service';
import { LeaveDetailModel } from '../entities/LeaveDetailModel';
import { EmpresaTreeViewService } from '../../employee/services/empresa-treeView.service';
import { DiagnosisService } from '../services/diagnosis.service';
import { finalize, map } from 'rxjs/operators';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { MatDialog } from '@angular/material/dialog';
import { BajaEditComponent } from './baja-edit/baja-edit.component';
import { Subscription } from 'rxjs';
import { SharedService } from 'app/modules/common/services/shared-service';
import { LeaveOperations } from 'app/modules/common/enums/leave-operations';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { DeleteMotivoDialogComponent } from './delete-motivo-dialog/delete-motivo-dialog.component';
import { ActuationService } from '../services/actuation.service';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import {
    ChangeLeaveTypeDialogComponent,
    ChangeLeaveTypeDialogData,
} from './change-leave-type-dialog/change-leave-type-dialog.component';
import { LeaveModel } from '../entities/NewLeaveModel';
import Utils from 'app/Utils';

@Component({
    selector: 'app-baja',
    templateUrl: './baja.component.html',
    styleUrls: ['./baja.component.scss'],
    standalone: false
})
export class BajaComponent implements OnInit, OnDestroy {
    SelectedLeaveDetail: LeaveDetailModel;
    LeaveOperations = LeaveOperations;
    marcaOptionList: any[];
    employee: any = null;
    prioritaria:string ="Prioritaria";

    isLeaveSelected = true;

    currentUser: any;
    showForthRow = false;
    showEdit = false;
    showMenu = false;
    showDelete = false;
    public isLoading = true;
    leaveInfo:any;
    selectedEmployeeId:number;

    EmpLeaveDetailSubcription: Subscription;

    constructor(
        public dialog: MatDialog,
        private leaveService: LeaveService,
        private empresaService: EmpresaTreeViewService,
        private diagnosisService: DiagnosisService,
        public employeeService: EmployeeService,
        public sharedService: SharedService,
        private pageLoader: PageLoaderService,
        public actuationService: ActuationService
    ) {
        this.SelectedLeaveDetail = new LeaveDetailModel();
        this.SubcribeEmployeeLeaveDetails();
       
    }

    SubcribeEmployeeLeaveDetails(): any {
        this.isLoading = true;
        this.EmpLeaveDetailSubcription = this.leaveService
            .SubscribeEmployeeLeaveDetails()
            .pipe(
                map((resp) => {
                    if (resp && resp.result) {
                        // Load Diagnosis codes
                        this.getEmpressa(resp.result.empresaId);
                        const leaveDetail = new LeaveDetailModel();
                        leaveDetail.LeaveId = resp.result.id;
                        leaveDetail.Tipo = this.getTypeDescription(
                            resp.result.tipo
                        );
                        leaveDetail.TipoChar = resp.result.tipo;
                        leaveDetail.Recaida = resp.result.recaida;
                        leaveDetail.Justificada = resp.result.justificada;
                        leaveDetail.Cronico = resp.result.cronico;
                        leaveDetail.Dias = resp.result.dias;
                        leaveDetail.CodDiagnostico = resp.result.codDiagnostico;
                        leaveDetail.leaveRef = resp.result.referencia;
                        leaveDetail.Diagnostico = resp.result.diagnostico;
                        leaveDetail.Actitud = resp.result.actitud;
                        leaveDetail.Agudo = resp.result.agudo;
                        leaveDetail.Cirujia = resp.result.cirujia;
                        leaveDetail.Embarazada = resp.result.embarazada;
                        leaveDetail.FCierre = resp.result.fCierre;
                        leaveDetail.Marcas = resp.result.marcas;
                        leaveDetail.NoVisitar = resp.result.noVisitar;
                        leaveDetail.Prioritaria = resp.result.prioritaria;
                        if (resp.result.fBaja != null) {
                            leaveDetail.FBaja = resp.result.fBaja.split('T')[0];
                        }
                        if (resp.result.fAlta != null) {
                            leaveDetail.FAlta = resp.result.fAlta.split('T')[0];
                        }
                        if (resp.result.avisoBaja != null) {
                            leaveDetail.AvisoBaja =
                                resp.result.avisoBaja.split('T')[0];
                        }
                        if (resp.result.avisoAlta != null) {
                            leaveDetail.AvisoAlta =
                                resp.result.avisoAlta.split('T')[0];
                        }
                        leaveDetail.DateDiffBaja = Math.floor(
                            DateHelper.getDateDifference(
                                resp.result.fBaja,
                                resp.result.avisoBaja
                            )
                        );
                        leaveDetail.DateDiffAlta = Math.floor(
                            DateHelper.getDateDifference(
                                resp.result.fAlta,
                                resp.result.avisoAlta
                            )
                        );
                        if (leaveDetail.DateDiffBaja === 1) {
                            leaveDetail.BajaDia = 'día';
                        } else if (leaveDetail.DateDiffBaja > 1) {
                            leaveDetail.BajaDia = 'días';
                        }
                        if (leaveDetail.DateDiffAlta === 1) {
                            leaveDetail.AltaDia = 'día';
                        } else if (leaveDetail.DateDiffAlta > 1) {
                            leaveDetail.AltaDia = 'días';
                        }
                        if (resp.result.fpa != null) {
                            leaveDetail.Fpa = resp.result.fpa.split('T')[0];

                            leaveDetail.DateDiffFpa = Math.floor(
                                DateHelper.getDateDifference(
                                    resp.result.fBaja,
                                    resp.result.fpa
                                )
                            );
                            leaveDetail.DateDiffFpa =
                                leaveDetail.DateDiffFpa + 1;

                            if (leaveDetail.DateDiffFpa > 1) {
                                leaveDetail.FpaDia = 'dias';
                            } else if (leaveDetail.DateDiffFpa === 1) {
                                leaveDetail.FpaDia = 'dia';
                            }
                        }

                        if (
                            resp.result.riesgosPsicosociales != null &&
                            resp.result.riesgosPsicosociales !== 'NO'
                        ) {
                            leaveDetail.RiesgosPsicosociales =
                                resp.result.riesgosPsicosociales.toUpperCase();
                        } else {
                            leaveDetail.RiesgosPsicosociales =
                                resp.result.riesgosPsicosociales;
                        }
                        this.leaveInfo=leaveDetail;
                        this.prioritariaButtonHandle();
                        return leaveDetail;
                    }
                })
            )
            .subscribe(
                (res) => {
                    if (!res) {
                        this.SelectedLeaveDetail = new LeaveDetailModel();
                        this.isLoading = false;
                        this.isLeaveSelected = false;
                        return;
                    }
                    this.checkShowforthRowPermission();
                    this.checkEditPermission();
                    this.checkDeletePermission();
                    this.SelectedLeaveDetail = res;
                    this.isLoading = false;
                    this.isLeaveSelected = true;
                },
                (error) => {
                    console.error(error);
                }
            );
    }

    ngOnInit(): void {
        this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
        if (
            this.sharedService.Permissions.HasPermisos601 ||
            this.sharedService.Permissions.HasPermisos612
        ) {
            this.showMenu = true;
        }

        this.marcaOptionList = this.getMarcusOptionsList();

        this.employeeService.subTrabajador.subscribe((res: any) => {
            this.employee = res;
            this.selectedEmployeeId=this.employee.trabajadorId;
        });
    }
    

    ngOnDestroy(): void {
        this.EmpLeaveDetailSubcription.unsubscribe();
    }

    private prioritariaButtonHandle()
    {
        if(this.leaveInfo.Prioritaria==null || this.leaveInfo.Prioritaria==undefined || this.leaveInfo.Prioritaria=='N')
        {
            this.prioritaria='Marcar Prioritaria';
        }else
        {
            this.prioritaria='Desmarcar Prioritaria';
           
        }
    }

    onClickPrioritaria()
    {
        this.pageLoader.ShowPageLoader();
        const obj={
            bajaid:this.leaveInfo.LeaveId,
            status:'S'
        }

        if(this.leaveInfo.Prioritaria==null || this.leaveInfo.Prioritaria==undefined || this.leaveInfo.Prioritaria=='N')
        {
            
            obj.status='S'
        }else
        {
            obj.status='N'
        }
        this.leaveService.UpdateBajaPrioritaria(obj.bajaid,obj.status).subscribe(res=>{
            if(res.result==true)
            {
                
                this.sharedService.ShowSnackBar('Actualizado correctamente');
                this.leaveService.PublishLeaves(Number(localStorage.getItem('EmplooyeeID')));

                this.SelectedLeaveDetail = new LeaveDetailModel();
                this.SubcribeEmployeeLeaveDetails();
                this.pageLoader.HidePageLoader();
            }else
            {
                this.sharedService.ShowSnackBar(' Error al actualizar');
            }
        },(err) => {
            console.error(err);
            this.pageLoader.HidePageLoader();
        })
    }

    /**
     * Get marcus options list for drop down
     */
    private getMarcusOptionsList() {
        return [
            {
                text: 'Marca de empresa',
                className: 'lbl3',
                label: 'E',
                isPermit: this.sharedService.Permissions.HasPermisos212,
            },
            {
                text: 'Marca de médico',
                className: 'lbl4',
                label: 'M',
                isPermit: this.sharedService.Permissions.HasPermisos212,
            },
            {
                text: 'Marca de coordinador',
                className: 'lbl2',
                label: 'C',
                isPermit: this.sharedService.Permissions.HasPermisos212,
            },
            {
                text: 'Marca de mutua',
                className: 'lbl8',
                label: 'U',
                isPermit: this.sharedService.Permissions.HasPermisos212,
            },
            {
                text: 'Marca externa',
                className: 'lbl7',
                label: 'X',
                isPermit: this.sharedService.Permissions.HasPermisos212,
            },
            {
                text: 'No citado por diagnóstico',
                className: 'lbl7',
                label: 'D',
                isPermit: this.sharedService.Permissions.HasPermisos212,
            },
            {
                text: 'No citado por zona',
                className: 'lbl7',
                label: 'Z',
                isPermit: this.sharedService.Permissions.HasPermisos223,
            },
            {
                text: 'Marca de simulación',
                className: 'lbl7',
                label: 'S',
                isPermit: this.sharedService.Permissions.HasPermisos212,
            },
            {
                text: 'Marca de salud mental',
                className: 'lbl7',
                label: 'L',
                isPermit:
                    this.sharedService.Permissions.HasPermisos212,
            },
        ];
    }

    private checkShowforthRowPermission(): void {
        if (this.sharedService.Permissions.HasPermisos505) {
            this.showForthRow = true;
        }
    }

    private checkEditPermission(): void {
        if (this.sharedService.Permissions.HasPermisos608) {
            this.showEdit = true;
        }
    }

    private checkDeletePermission(): void {
        if (this.sharedService.Permissions.HasPermisos615) {
            this.showDelete = true;
        }
    }

    private getEmpressa(companyId): void {
        this.empresaService.getEmpresa(companyId).subscribe(
            (resp) => {
                // this.getDiagnosis(resp.result.tipoDiagnostico)
            },
            (err) => {
                console.error(err);
            }
        );
    }

    private getDiagnosis(diagnosisType: string): any {
        this.diagnosisService
            .GetDiagnosisCode(diagnosisType)
            .pipe(
                map((resp) => {
                    return resp.result.map((element) => {
                        return {
                            code: element.codigo,
                            descripcion: element.descripcion,
                            Id: element.id,
                        };
                    });
                })
            )
            .subscribe(
                (resp) => {
                    localStorage.setItem(
                        'DiagnosisCodes',
                        JSON.stringify(resp)
                    );
                },
                (err) => {
                    console.error(err);
                }
            );
    }

    private getTypeDescription(letter): string {
        let result: string;
        switch (letter) {
            case 'E':
                result = 'Enfermedad';
                break;
            case 'F':
                result = 'Enfermedad profesional';
                break;
            case 'A':
                result = 'Accidente laboral';
                break;
            case 'N':
                result = 'Accidente no laboral';
                break;
            case 'S':
                result = 'Accidente sin baja';
                break;
            case 'R':
                result = 'Riesgo por embarazo';
                break;
            case 'M':
                result = 'Maternidad';
                break;
            case 'P':
                result = 'Permiso';
                break;
            case 'I':
                result = 'Indisposición';
                break;
            case 'B':
                result = 'Permiso retribuido';
                break;
            case 'U':
                result = 'Permiso no retribuido';
                break;
            case 'H':
                result = 'Horas sindicales';
                break;
        }
        return result;
    }

    OpenEditDialog(): void {
        const editDialogRef = this.dialog.open(BajaEditComponent, {
            width: '700px',
            minWidth: '700px',
            autoFocus: false,
        });
        editDialogRef.afterClosed().subscribe((result) => {});
    }

    // delete a leave
    public DeleteLeave() {
        // get confirmation to delete
        const dialogData = new ConfirmDialogModel(
            '¿Eliminar esta baja con todas sus actuaciones y tareas?',
            ''
        );
        const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
            data: dialogData,
        });

        // get reason and delete leave
        confirmDialog.afterClosed().subscribe((res) => {
            if (res) {
                this.dialog.open(DeleteMotivoDialogComponent, {
                    data: {
                        leaveId: this.SelectedLeaveDetail.LeaveId,
                    },
                });
            }
        });
    }
    public ReabrirBaja() {
        // show confimation dialog
        const obj={
            leaveId:this.leaveInfo.LeaveId,
        }
        const dialogData = new ConfirmDialogModel(
            'Se va a reabrir la Baja ¿Desea continuar?',
            ''
        );
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: dialogData,
        });

        dialogRef.afterClosed().subscribe((responce) => {
            if (responce) {
                this.leaveService.ReabrirBaja(obj.leaveId).subscribe(res=>{
                    if(res.result==true)
                    {
                        this.sharedService.ShowSnackBar('Actualizado correctamente');
                        this.leaveService.PublishLeaves(Number(localStorage.getItem('EmplooyeeID')));
        
                        this.SelectedLeaveDetail = new LeaveDetailModel();
                        this.SubcribeEmployeeLeaveDetails();
                        this.pageLoader.HidePageLoader();
                    }else
                    {
                        this.sharedService.ShowSnackBar(' Error al actualizar');
                    }
                },(err) => {
                    console.error(err);
                    this.pageLoader.HidePageLoader();
                })
            }
        });
    }


    /**
     * Handle Pasar a Baja link click
     */
    public PasarBajaClickHandler() {
        // show confimation dialog
        const dialogData = new ConfirmDialogModel(
            '¿Pasar la indisposición a baja?',
            ''
        );
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: dialogData,
        });

        dialogRef.afterClosed().subscribe((responce) => {
            if (responce) {
                // pasar baja
                const emplooyeeID = Number(localStorage.getItem('EmplooyeeID'));
                this.pasarBaja(this.SelectedLeaveDetail.LeaveId, emplooyeeID);
            }
        });
    }

    /**
     * Pasar a Baja
     * @param bajaId Leave ID
     */
    private pasarBaja(bajaId: number, trabajadorId: number) {
        this.leaveService.pasarBaja(bajaId, trabajadorId).subscribe(
            (res) => {
                if (res.code === 0) {
                    this.sharedService.ShowSnackBar('exitoso');
                    // reload leaves list
                    const emplooyeeId = localStorage.getItem('EmplooyeeID');
                    this.leaveService.PublishLeaves(Number(emplooyeeId));
                } else {
                    console.error('Server error: ' + res.message);
                    this.sharedService.ShowSnackBar(
                        'Lo siento, el proceso falló'
                    );
                }
            },
            (err) => {
                console.error(err);
                this.sharedService.ShowSnackBar('Lo siento, el proceso falló');
            }
        );
    }

    public openChangeLeaveTypeDialog() {
        const data: ChangeLeaveTypeDialogData = {
            leaveId: this.SelectedLeaveDetail.LeaveId,
            employeeId: Number(localStorage.getItem('EmplooyeeID')),
        };

        this.dialog
            .open(ChangeLeaveTypeDialogComponent, {
                data,
            })
            .afterClosed()
            .subscribe((res: boolean) => {
                if (res) {
                    const emplooyeeId = localStorage.getItem('EmplooyeeID');
                    this.leaveService.PublishLeaves(Number(emplooyeeId));
                }
            });
    }

    //#region EVENTS

    /**
     * Toggle mark event handler
     */
    public async toggleMarca(
        leaveRow: LeaveDetailModel,
        marca: { label: string },
        checked: boolean
    ): Promise<void> {
        this.pageLoader.ShowPageLoader();

        try {
            leaveRow.Marcas = await this.leaveService.toggleMarca(
                leaveRow,
                marca.label,
                checked
            );
        } catch (error) {
            this.sharedService.ShowSnackBar('Actualización de marca fallida');
            console.error(error);
        }

        this.pageLoader.HidePageLoader();
    }

    //#endregion

    //#region PASTE ACTIONS

    /**
     * Paste actions
     */
    public pasteActions(leaveId: number) {
        this.pageLoader.ShowPageLoader();

        this.actuationService
            .pasteActions(leaveId)
            .pipe(finalize(() => this.pageLoader.HidePageLoader()))
            .subscribe(
                (res) => {
                    if (res.code === 0) {
                        this.sharedService.ShowSnackBar(
                            'Acciones copiadas con éxito'
                        );

                        // remove cut data
                        this.actuationService.clearActionCutData();

                        // reload leaves list
                        const emplooyeeId = localStorage.getItem('EmplooyeeID');
                        this.leaveService.PublishLeaves(Number(emplooyeeId));
                    } else {
                        this.sharedService.ShowSnackBar(
                            'Lo siento, las acciones de copia han fallado'
                        );
                        console.error(res.message);
                    }
                },
                (err) => {
                    this.sharedService.ShowSnackBar(
                        'Lo siento, las acciones de copia han fallado'
                    );
                    console.error(err);
                }
            );
    }

    //#endregion
}
